const actions = {
  FETCH_CARD_DATA: "fetchCardData",
  FETCH_CARD_PIN: "fetchCardPin",
  PUT_CARD_STATUS_AS_LOST: "putCardStatusAsLost",
  PUT_CARD_STATUS_AS_STOLEN: "putCardStatusAsStolen",
  PUT_CARD_STATUS_AS_FROZEN: "putCardStatusAsFrozen",
  PUT_CARD_STATUS_AS_ACTIVE: "putCardStatusAsActive",
  PUT_NEW_CARD_PIN: "putNewCardPin",
  PUT_CONFIRM_CODE_TO_SET_NEW_CARD_PIN: "putConfirmCodeToSetNewCardPin",
  POST_SMS_CODE_TO_GET_OLD_TRANSACTIONS_ACCESS_TOKEN:
    "postSmsCodeToGetOldTransactionsAccessToken",
  FETCH_ALL_TRANSACTIONS: "fetchAllTransactions",
  FETCH_LATEST_TRANSACTIONS: "fetchLatestTransactions"
};

export default actions;
